export default "__VITE_ASSET__DegcRhJp__"